<template>

    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h2 class="mb-4">{{__('lang.output.options')}}</h2>
                <h4 class="mb-4">{{__('lang.output.pdfcreate')}}</h4>
                <form class="needs-validation" method="post" novalidate="novalidate">

                    <div class="form-row">
                        <div class="form-group col-12">
                            <!--                    <h6>{{__('lang.output.text.choosecontent')}}</h6>-->
                            <b-form-checkbox class="mb-3" v-model="selectAll" @change="toggleSelectAll">{{ __('lang.global.select_all') }}</b-form-checkbox>
                            <b-form-checkbox  v-for="option in optionsTableOfContents"
                                              v-model="optionsTableOfContentsselected"  :key="option.value" :value="option.value"
                                              name="content" stacked> {{ option.text }}

                                <div v-if="option.value==2 && optionsTableOfContentsselected.includes(2) && user.auth" class="form-group col-12">
                                    <b-form-radio v-model="doctypeselected" name="doctype" value="1">
                                        {{__('lang.output.rb.offer')}}</b-form-radio>
                                    <b-form-radio v-model="doctypeselected" name="doctype" value="2">
                                        {{__('lang.output.rb.request')}}</b-form-radio>
                                </div>
                            </b-form-checkbox>

                        </div>
                    </div>
                    <div class="form-row mb-4">
                        <div class="form-group col-12 col-md-6 order-1 order-md-2">
                            <a class="btn btn-primary btn-block border-0" href="#"
                               @click.prevent="makePDF()">{{__('lang.btn.makepdf')}}</a>
                        </div>
                    </div>
                </form>
                <h4 class="mb-4">{{ __('lang.output.text.shoppingcartasformat') }}</h4>
                <ul class="nav nav-justified mb-5">
                    <li class="nav-item mx-3"><a class="btn btn-primary btn-block border-0"
                                                 href="#" @click.prevent="makeExcel()" >{{ __('lang.output.btn.excel') }}</a></li>
                    <li class="nav-item"><a class="btn btn-primary btn-block border-0" href="#"
                                            @click.prevent="makeGAEB()">{{ __('lang.output.btn.gaeb') }}</a></li>
                </ul>

                <h4 class="mb-4">{{__('lang.output.text.longtext')}}</h4>
                <p>{{__('lang.output.text.chooseformat')}}</p>
                <ul class="nav nav-justified mb-5">
                    <li class="nav-item"><a class="btn btn-primary btn-block border-0" href="#" @click.prevent="makeText()">{{__('lang.output.btn.text')}}</a>
                    </li>
                </ul>
                <h4 class="mb-4">{{__('lang.output.text.tecnicaldocs_download')}}</h4>
                <p>{{__('lang.output.text.tecnicaldocs_zip')}}</p>
                <p><a class="btn btn-primary btn-block border-0" href="#" @click.prevent="createZip">
                    <svg class="icon">
                        <use xlink:href="/assets/img/icon-sprite.svg#global.form.send" xmlns:xlink="http://www.w3.org/1999/xlink">
                        </use>
                    </svg>{{__('lang.output.text.tecnicaldocs_zip_download')}}</a></p>
            </div>
        </div>
    </div>




</template>

<script>
import axios from './services/api/axiosConfig'
import moment from "moment/moment";
export default {
    props:['discountshow'],
    computed: {
        user: {
            get() {
                console.log('was hat hier user:')
                console.log(this.$store.state.user.user)

                return this.$store.state.user.user
            },
            set(value) {
                this.$store.commit('user/updateUser', value)
            }
        },
        user_settings: {
            get() {
                console.log('was hat hier user_settings:')
                console.log(this.$store.state.operatingpoint.user_settings)
                return this.$store.state.operatingpoint.user_settings
            }
        },
        configuration: {
            get () {
                return this.$store.state.user.configuration
            },
            set (value) {
                this.$store.commit('user/updateConfiguration', value)
            }
        },
        shoppingcartlist:{
            get() {
                console.log('shoppingcartlist im output:')
                console.log(this.$store.state.shoppingcart.shoppingcartlist)
                return this.$store.state.shoppingcart.shoppingcartlist
            }
        },
        shoppingcartnetto: {
            get() {
                return this.$store.state.shoppingcart.shoppingcartnetto
            }
        },
        projectData: {
            get () {
                return this.$store.state.user.projectData
            },
        },
        session: {
            get () {
                return this.$store.state.user.session
            },
        },

        /*  projectStore: function(){

           var project={}
           project.contacts=[]
           project.configuration={description:'this.projectStore.configuration.description'}
           project.number='this.projectStore.number'
           project.editor='this.projectStore.configuration.editor'
           project.contacts.push({ type: 'contact.type',
               company: 'contact.company_name',
               street: 'contact.company_street',
               postCode: 'contact.company_post_code',
               city: 'contact.company_city',
               country: 'contact.company_country',
               contactPerson: 'contact.first_name' + ' ' + 'contact.last_name',
               phone: 'contact.phone',
               mobile: 'contact.mobile',
               fax: null})


           return project
         }, */
        projectStore: {
            get() {
                return this.$store.state.projectData.project   ////ToDo: add usersettings vat, freight_position,.... to this.$store.state.user.projectData.project.offer
            },
        },

    },
    data() {
        return {
            Project: {},
            Contacts: [],
            Articles: [],
            optionsTableOfContentsselected: [],
            optionsTableOfContents: [
                { value: 1, text: this.__('lang.output.cb.project_saler'), id:'projectdata', tag:'projectdata' },
                { value: 2, text: this.__('lang.output.material.list'), id: 'offer', tag: 'shoppingcart'  },
                { value: 3, text: this.__('lang.output.cb.technical_datasheets'), id: 'datasheet', tag: 'techdata' },
                { value: 4, text: this.__('lang.output.cb.accessories_details'), id: 'accessories', tag: 'accessories' },
                { value: 5, text: this.__('lang.output.cb.wiringdiagram'), id: 'ssplan', tag: 'ssplan' }
            ],
            TableOfContents: [],
            doctypeselected:2,
            selectAll: true,
        }
    },
    methods: {
        // Method to toggle the state of all checkboxes based on the "Select All" checkbox
        toggleSelectAll() {
            if (this.selectAll) {
                // If "Select All" is checked, set all checkboxes to selected
                this.optionsTableOfContentsselected = this.optionsTableOfContents.map(option => option.value);
            } else {
                // If "Select All" is unchecked, clear all selected checkboxes
                this.optionsTableOfContentsselected = [];
            }
        },
        makePDF() {
            document.getElementsByTagName("body")[0].classList.add("is-loading");
            this.createObjectStructure()
            this.generateXml()

        },
        generateXml() {
            axios.post('/create/xml',
                {
                    project: this.Project
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/pdf'
                    },
                    responseType: "blob"
                }
            )
                .then(response => {
                    document.getElementsByTagName("body")[0].classList.remove("is-loading");
                    const blob = new Blob([response.data], { type: 'application/pdf' })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = 'HeliosSelect.pdf'
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch(console.error)
        },
        /*GAEB:*/
        makeGAEB() {
            document.getElementsByTagName("body")[0].classList.add("is-loading");
            this.createObjectStructure()
            //ToDo: evntl. to services/api/project.js with language  url: `/${window._locale}/` +'get/gaeb',
            axios.post('/get/gaeb',
                { project: this.Project },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/x81'
                    },
                    responseType: "blob"
                }
            )
                .then(response => {
                    document.getElementsByTagName("body")[0].classList.remove("is-loading");
                    const blob = new Blob([response.data], { type: 'application/x81' })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = 'HeliosSelectGAEB.X81'
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch(console.error)

        },
        makeExcel() {
            document.getElementsByTagName("body")[0].classList.add("is-loading");
            this.createObjectStructure()
            axios.post('/create/excel',
                { project: this.Project },
                { responseType: 'arraybuffer' })
                .then(response => {
                    document.getElementsByTagName("body")[0].classList.remove("is-loading");
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var link = document.createElement('a');
                    link.href = fileURL;
                    link.setAttribute('download', 'HeliosSelect.xlsx');
                    document.body.appendChild(link);
                    link.click();
                })
        },
        makeText() {
            document.getElementsByTagName("body")[0].classList.add("is-loading");
            this.createObjectStructure()
            axios.post('/create/text',
                { project: this.Project },
                { responseType: 'blob' })
                .then(response => {
                    document.getElementsByTagName("body")[0].classList.remove("is-loading");
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var link = document.createElement('a');
                    link.href = fileURL;
                    link.setAttribute('download', 'HeliosSelect.txt');
                    document.body.appendChild(link);
                    link.click();
                })
        },
        createObjectStructure(){

            var ArticleList=this.$store.state.shoppingcart.shoppingcartlist

            this.createArticleStructure(ArticleList);
            this.createProjectStructure();
            this.createContactsStructure();
            this.createTableOfContentsStructure();

            this.Project.Articles = this.Articles;
            this.Project.Contacts = this.Contacts;
            this.Project.TableOfContents = this.TableOfContents

        },
        createProjectStructure() {

            /*  this.Project = {
                description: this.projectStore.configuration.description,
                number: this.projectStore.number,
                editor: this.projectStore.configuration.editor,
                configurationdate: this.projectStore.configuration.updated??null,
                delivery:null,
                freight: this.projectStore.offer.freight_position??null, //usersettings 'freight_position'
                offervalidaty:null,
                nettoprice: this.doctypeselected==1?this.shoppingcartnetto:null,
                offervat: this.projectStore.offer.vat ??null, //usersettings 'vat'
                bruttoprice: this.doctypeselected == 1 ? parseFloat(this.shoppingcartnetto * this.projectStore.offer.vat /100).toFixed(2): null,
                note: this.projectStore.description,
                language_id: this.$lang().locale,
                doctype: this.doctypeselected

            }  */
            console.log('this.user_settings.vat:',this.user_settings.vat)  //usersettings 'vat'
            var vat = parseFloat(this.user_settings.vat)>0 ? parseFloat(this.user_settings.vat).toFixed(2) : (parseFloat(this.projectStore.offer.vat)>0 ? parseFloat(this.projectStore.offer.vat).toFixed(2) : 0.00);
            var freight = this.user_settings.freight_position?this.user_settings.freight_position : (this.projectStore.offer.freight_position ? this.projectStore.offer.freight_position : '');


            var now = moment();
            //var lastedit = moment(now, "DD.MM.YYYY");
            var lastedit = moment();
            if(this.projectStore.configuration.updated){
                //lastedit = moment( String(this.projectStore.configuration.updated), "YYYY-MM-DD HH:mm:ss.SSSSSS").format("DD.MM.YYYY");
                lastedit = moment( String(this.projectStore.configuration.updated), "YYYY-MM-DD HH:mm:ss.SSSSSS")
            }
            var offervalidaty = moment(lastedit, 'YYYY-MM-DD;HH:mm:ss').add('4', 'weeks').format("DD.MM.YYYY");
            var  shoppingcartnetto = parseFloat(this.shoppingcartnetto) >0 ? parseFloat(this.shoppingcartnetto):0

            this.Project = {
                description: this.projectStore.configuration.description,
                number: this.projectStore.number,
                name: this.projectStore.name,
                configuration_name: this.projectStore.configuration.description,
                editor: this.projectStore.configuration.editor,
                configurationdate: this.projectStore.configuration.updated ?? null,
                delivery: null,
                freight: freight,  //this.projectStore.offer.freight_position ?? null, //usersettings 'freight_position'
                offervalidaty: offervalidaty, //null,
                nettoprice: this.doctypeselected == 1 ? this.shoppingcartnetto : null,
                offervat: parseFloat(vat).toFixed(2), //usersettings 'vat'
                //vat: this.doctypeselected == 1 ? parseFloat(shoppingcartnetto * vat / 100).toFixed(2) : 0.00,
                vat: this.doctypeselected == 1 ? parseFloat(shoppingcartnetto * vat / 100).toFixed(2) : '',
                //bruttoprice: this.doctypeselected == 1 ? parseFloat(parseFloat(shoppingcartnetto) + parseFloat(shoppingcartnetto * vat / 100)).toFixed(2) : 0.00,
                bruttoprice: this.doctypeselected == 1 ? parseFloat(parseFloat(shoppingcartnetto) + parseFloat(shoppingcartnetto * vat / 100)).toFixed(2) : '',
                note: this.projectStore.description,
                language_id: this.$lang().locale,
                doctype: this.doctypeselected
            }


            console.log('createProjectStructure this.projectStore:')
            console.log(this.projectStore)
            console.log('createProjectStructure this.Project:')
            console.log(this.Project)
        },
        createContactsStructure() {
            this.Contacts = [];
            this.projectStore.contacts.forEach(function (contact) {
                if (contact.type == 1) {
                    this.Contacts.push({
                        Contact: {
                            type: contact.type,
                            company: this.projectStore.customer.company_name,
                            street: this.projectStore.street,
                            postCode: this.projectStore.post_code,
                            city: this.projectStore.city,
                            country: this.projectStore.country,
                            contactPerson:  this.projectStore.customer.first_name + ' ' +  this.projectStore.customer.last_name,
                            phone:  this.projectStore.customer.phone,
                            mobile:  this.projectStore.customer.mobile,
                            mail:  this.projectStore.customer.email

                        }
                    })
                }
                else {
                    this.Contacts.push({
                        Contact: {
                            type: contact.type,
                            company: contact.company_name,
                            street: contact.company_street,
                            postCode: contact.company_post_code,
                            city: contact.company_city,
                            country: contact.company_country,
                            contactPerson: contact.first_name + ' ' + contact.last_name,
                            phone: contact.company_phone,
                            mobile: contact.company_mobile,
                            mail: contact.email

                        }
                    })
                }
            }.bind(this));
            //DraftingFrom - userprofildata contact.type ist not defined (may be use 3 - planner), i defined here static 7 for use in FODesigner
            if (this.user.auth) {
                this.Contacts.push({
                    Contact: {
                        type: 7,
                        company: this.user.company_name,
                        street: this.user.street + ' ' +  this.user.house_number,
                        postCode: this.user.post_code,
                        city: this.user.city,
                        country: this.user.countries_id,
                        contactPerson: this.user.first_name + ' ' + this.user.last_name,
                        phone: this.user.person_phone,
                        mobile: this.user.person_mobile,
                        mail: this.user.email,
                        fax: this.user.company_fax,

                    }
                })

            }


        },
        createArticleStructure(ArticleList) { //ArticleList=shoppingcartlist

            var flagFan = '';
            var descriptionlong ='';
            var articleprice=0.00;
            var version = '';
            var artNo = ''
            var descriptionshort = '';
            var pos = 0
            var productmarker='0';
            var wg ='';

            this.Articles = []

            ArticleList.forEach(function (article) {
                console.log('article:')
                console.log(article)

                if (article.quantity <= 0 && article.productmarker == 0 ) return
                if (article.productmarker != -1 && article.productmarker != -2) pos++

                if (article.product_source != 1) { /*UserArtikel*/
                    artNo = article.ref_no
                    version = article.version
                    /*descriptionshort = article.designation*/
                    descriptionshort = article.description_short//article.description
                    descriptionlong = article.description_short//article.description
                    articleprice = article.price && parseFloat(article.price )>0 ?parseFloat(article.price ).toFixed(2):0.00
                    flagFan = ''
                    productmarker= article.productmarker
                    wg =  article.article_group??''

                }
                else { /*HeliosArtikel*/
                    artNo = article.ref_no
                    version = article.version ? article.version : article.product_child_version
                    descriptionshort = article.description_short
                    descriptionlong = article.description_long
                    articleprice = article.price && parseFloat(article.price )>0 ?parseFloat(article.price ).toFixed(2):0.00
                    flagFan = article.flag_fan ? article.flag_fan : 2
                    productmarker = article.productmarker
                    wg =  article.wg

                }

                var articlepricediscounted = ((parseFloat(articleprice) * (100 - parseFloat(article.discount_1)) / 100) * (100 - parseFloat(article.discount_2)) / 100).toFixed(2)
                //if(this.discountshow && this.doctypeselected == 1 && parseFloat(articleprice))  articleprice= articlepricediscounted
                /*
                              var modifiedUrl=''
                              if(article.image) {
                                  var originalUrl = article.image ??''
                                  // Replace 'image' with 'image_72dpi'
                                  modifiedUrl = originalUrl.replace('image', 'image_72dpi');
                              }*/


                this.Articles.push({
                    Article: {
                        position: article.productmarker != -1 && article.productmarker != -2 ? pos : 0,
                        artNo: artNo,
                        version: version,
                        execution: article.execution ?? 0,
                        name: article.type,
                        details: descriptionshort,
                        descriptionlong: descriptionlong,
                        language_id: this.$lang().locale, //navigator.language,
                        picturePath: article.image ?? '',
                        wg: wg,
                        discount1: article.discount_1 > 0 && this.discountshow ? article.discount_1 : '',
                        discount2: article.discount_2 > 0 && this.discountshow ? article.discount_2 : '',
                        //price: this.doctypeselected == 1 && parseFloat(articleprice) .toFixed(2) ?    parseFloat(articleprice).toFixed(2)  : 0.00,
                        price: this.doctypeselected == 1 && parseFloat(articleprice).toFixed(2) ? parseFloat(articleprice).toFixed(2) : '',
                        quantity: article.quantity,
                        //totalPrice: this.doctypeselected == 1 && article.productmarker==0 ? parseFloat((this.discountshow ? articlepricediscounted : articleprice) * article.quantity).toFixed(2) : 0.00,
                        totalPrice: this.doctypeselected == 1 && article.productmarker == 0 ? parseFloat((this.discountshow ? articlepricediscounted : articleprice) * article.quantity).toFixed(2) : '',
                        textposition: article.positiontext,
                        productSource: article.product_source,
                        flagFan: flagFan,
                        flagacoustic: 1,
                        productmarker: productmarker,
                        subsum: this.doctypeselected == 1 ? parseFloat(article.subsum).toFixed(2) : null,
                        op: article.op

                    }

                });
            }.bind(this))
            console.log('createArticleStructure:')
            console.log(this.Articles)
        },
        createTableOfContentsStructure() {
            this.TableOfContents = [];
            this.optionsTableOfContents.forEach(function (content) {
                var contentdata = {
                    id: content.value,
                    name: content.text,
                    show: this.optionsTableOfContentsselected.includes(content.value) ? 1 : 0
                }
                var contenttag = {[content.tag]: contentdata}
                this.TableOfContents.push({
                    Content: contenttag
                });
            }.bind(this))
        },

        setInputLabels: function (value) {
            value.forEach(function (item) {
                if (item.hasOwnProperty('text')) {
                    item.text = this.__(item.text)
                }
                if (item.hasOwnProperty('label')) {
                    item.label = this.__(item.label)
                }
            }.bind(this))
            return value;
        },
        /*:GAEB*/
        /*Zip:*/
        createZip() {
            document.getElementsByTagName("body")[0].classList.add("is-loading");
            this.createObjectStructure()
            // Make an API request to Laravel to create the ZIP file
            axios.post('/create/zip', {project: this.Project}, {responseType: "blob"})
                .then(response => {
                    // Handle the response, e.g., show a success message or download the ZIP
                    document.getElementsByTagName("body")[0].classList.remove("is-loading");
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]), {type: 'application/zip'});
                    var link = document.createElement('a');
                    link.href = fileURL;
                    link.setAttribute('download', 'HeliosSelect.zip');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    console.log('create zip')
                })
                .catch(error => {
                    // Handle errors
                    console.log('create zip failed')
                });
        },
        /*:Zip*/


    },
    mounted() {
        this.toggleSelectAll();

    },
    created() {
    },
    watch: {
        // Watch for changes in the selected checkboxes and update "Select All" accordingly
        optionsTableOfContentsselected: {
            handler(newValue) {
                // Check if all checkboxes are selected
                this.selectAll = newValue.length === this.optionsTableOfContents.length;
                this.doctypeselected = this.optionsTableOfContentsselected.includes(2) ? this.doctypeselected : 2
            },
            deep: true, // Watch changes deeply within the array
        },

        /*
              optionsTableOfContentsselected: {
                deep: true,
                handler() {
                  this.doctypeselected = this.optionsTableOfContentsselected.includes(2) ? this.doctypeselected : 2
                }
              }*/

    },
}


</script>
